import { ComponentStyleConfig } from '@chakra-ui/react';
import { getColorVar } from '@chakra-ui/theme-tools';

export const TextareaStyles: ComponentStyleConfig = {
  baseStyle: (props) => {
    return {
      '&&': {
        background: 'field',
      },
      borderRadius: '8px',
      outline: '2px solid transparent',
      '&&&': {
        boxShadow: 'none',
        borderColor: 'border.layer.0',
      },
      _hover: {
        background: `color-mix(in srgb, ${getColorVar(props.theme, 'field')} 90%, ${getColorVar(props.theme, 'gray.400')} 10%)`,
        '&&': {
          borderColor: 'border.1',
        },
      },
      _focusVisible: {
        outlineColor: 'state.selected',
      },
      _active: {
        background: 'field.active',
        '&&': {
          borderColor: 'state.selected',
        },
      },
      _invalid: {
        '&&&': {
          borderColor: 'state.error',
        },
      },
      _disabled: {
        opacity: 1,
        color: 'text.disabled',
        '&&&': {
          borderColor: 'border.1',
        },
      },
      _readOnly: {
        background: 'layer.0',
        cursor: props.cursor ?? 'not-allowed',
        '&&&': {
          borderColor: 'border.layer.0',
        },
      },
    };
  },
  defaultProps: {
    errorBorderColor: 'red.300',
  },
  sizes: {
    xs: {
      px: 2, // 8px
    },
    sm: {
      px: 2,
    },
    md: {
      px: 2,
    },
    lg: {
      px: 3, // 12px
    },
  },
};
